import React from "react"
import styled from "styled-components"

const TimelineWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 3em;
  margin-top: 40px;

  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }

  @media only screen and (min-width: 768px) and (max-width: 991px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

const TimelineItem = styled.div`
  position: relative;
  padding-top: 10px;
  padding-left: 0;

  @media only screen and (min-width: 768px) {
    &:not(:first-child) {
      border-left: 1px solid rgba(255, 255, 255, 0.4);
      padding-left: 24px;
    }
  }
`

const TimelineLabel = styled.h4`
  margin: 0 0 8px 0;
  font-family: var(--font-bold);
  font-size: 1.1em;
  color: var(--four-color);
`

const TimelineDescription = styled.p`
  margin: 0;
  font-family: var(--font-md);
  font-size: 0.95em;
  color: var(--four-color);
  line-height: 1.7em;
`

const TrayectoriaTimeline = () => {
  const items = [
    {
      title: "Mejora",
      description:
        "Trayectoria consolidada en infraestructura y financiamiento",
    },
    {
      title: "Compromiso",
      description: "Soluciones que mejoran la movilidad y conectividad",
    },
    {
      title: "Dedicación",
      description: "Análisis que impulsan proyectos viables y rentables",
    },
  ]

  return (
    <TimelineWrapper>
      {items.map((item, index) => (
        <TimelineItem key={index}>
          <TimelineLabel>{item.title}</TimelineLabel>
          <TimelineDescription>{item.description}</TimelineDescription>
        </TimelineItem>
      ))}
    </TimelineWrapper>
  )
}

export default TrayectoriaTimeline
